import React, { Component, Fragment } from 'react';
import getLabel from './../../../../../utils/labels'
import checkIcon from './../../../../../globals/images/option-selected.svg'

import './clientOrgChart.scss';

class ClientOrgChart extends Component {
  getClientActors = (actors) => {
    let { checkIfOptionPresentInArray, selectedActors } = this.props;
    return actors.map((actor, key) => {
      let isHighlighted = checkIfOptionPresentInArray(selectedActors, actor.id);
      return (
        <div className="node-contents" key={key} style={isHighlighted ?
          {
            backgroundColor: '#ededff',
            borderColor: "#7f7fce"
          }
          :
          {}} onClick={() => this.props.onOptionClick(actor.id)}>
          <div className="image">
            {isHighlighted ? <img src={checkIcon} alt="checkicon" /> : null}
          </div>
          <div className="image-container">
            <img className="node-image" src={actor.gravatar} />
          </div>
          <div className='text'>
            <div className='name'>
              {`${actor.first_name} ${actor.last_name}`}
            </div>
            <div>
              {actor.role},
            </div>
            <div>
              {actor.company}
            </div>
          </div>
        </div>
      )
    })
  }

  render() {
    return (
      <div style={{ backgroundColor: '#f1f1f6', width: '1125px' }}>
        <div className="hr-line"></div>
        <div style={{ position: 'relative' }}>
          <div className="client-org-chart">
            {this.getClientActors(this.props.actors.clients)}
          </div>
          <div className="chart-type">{getLabel('label_client_chart')}</div>
        </div>
      </div>)
  }
}

export default ClientOrgChart


// WEBPACK FOOTER //
// /src/components/mailThread/compose/actorsHandler/clientOrgChart/ClientOrgChart.js